import { render, staticRenderFns } from "./dingzhiFormDetail.vue?vue&type=template&id=76c9d60c&scoped=true&"
import script from "./dingzhiFormDetail.vue?vue&type=script&lang=js&"
export * from "./dingzhiFormDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c9d60c",
  null
  
)

export default component.exports